<c-task-list type="'competency'" class="task-list"></c-task-list>